const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "310px",
		lablewith: "110px",
		btx: true,
		options: [],
	},
	{
		inputdata: "",
		title: "院区/科室",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: true,
	},
	{
		inputdata: "",
		title: "医院",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请搜索选择",
		types: "hospital",
		inputtype: "selectautocomplete",
		pt: true,
		width: "310px",
		lablewith: "110px",
		btx: true,
		options: [],
	},
	{
		inputdata: "",
		title: "类型",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "310px",
		lablewith: "110px",
		btx: true,
		options: [],
	},
	{
		inputdata: "",
		title: "术者",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	}
];
export default fromdata;
